import React from 'react';
import { useSelector } from 'react-redux';

// Reusable ListItem Component
const ListItem = ({ text }) => (
    <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '10px' }}>
        <span style={{ color: 'red', fontWeight: 'bold', marginRight: '10px' }}>✔</span>
        <span>{text}</span>
    </li>
);

// Section Component
const Section = ({ title, items, paragraphs, isRtl }) => (
    <div style={{ 
        marginBottom: '40px',
        direction: isRtl ? 'rtl' : 'ltr',
        textAlign: isRtl ? 'right' : 'left'
    }}>
        <h2 style={{ fontSize: '24px', fontWeight: 'bold' }}>{title}</h2>
        <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
            {items.map((text, index) => (
                <ListItem key={index} text={text} />
            ))}
        </ul>
        {paragraphs?.map((p, idx) => (
            <p key={idx} style={{ marginTop: '10px' }}>{p}</p>
        ))}
    </div>
);

// Main Component
const IncludedAndSolution = () => {
    const { language } = useSelector((state) => state.language);
    const isRtl = language === 'sa';

    const translations = {
        gb: {
            includedTitle: "What's Included",
            solutionTitle: "Customized Solution",
            sampleText: "Netus platea nec commodo tincidunt felis orci iaculis facilisi. Molestie etiam magnis rutrum penatibus eros non accumsan erat nulla,",
            longText: "Netus platea nec commodo tincidunt felis orci iaculis facilisi. Molestie etiam magnis rutrum penatibus eros non accumsan erat nulla, convallis rhoncus natoque lacinia class viverra platea cubilia, netus luctus tristique quam habitasse taciti nullam fringilla nostra netus class felis magnis sed consequat orci."
        },
        sa: {
            includedTitle: "ما المدرج",
            solutionTitle: "حل مخصص",
            sampleText: "نيتوس بلاتيا نيك كومودو تينسيدونت فيليس أورسي إياكوليس فاسيليسي. مولستي إتيام ماجنيس روتوم بيناتيبوس إيروس نون أكومسان إيرات نولا،",
            longText: "نيتوس بلاتيا نيك كومودو تينسيدونت فيليس أورسي إياكوليس فاسيليسي. مولستي إتيام ماجنيس روتوم بيناتيبوس إيروس نون أكومسان إيرات نولا، كونفاليس رونكوس ناتوكي لاكينيا كلاس فيفيرا بلاتيا كوبيليا، نيتوس لكتوس تريستيكي كوام هابيتاسي تاكيتي نولام فرينجيلا نوسترا نيتوس كلاس فيليس ماجنيس سيد كونسيكوات أورسي."
        },
        fr: {
            includedTitle: "Ce qui est inclus",
            solutionTitle: "Solution personnalisée",
            sampleText: "Netus platea nec commodo tincidunt felis orci iaculis facilisi. Molestie etiam magnis rutrum penatibus eros non accumsan erat nulla,",
            longText: "Netus platea nec commodo tincidunt felis orci iaculis facilisi. Molestie etiam magnis rutrum penatibus eros non accumsan erat nulla, convallis rhoncus natoque lacinia class viverra platea cubilia, netus luctus tristique quam habitasse taciti nullam fringilla nostra netus class felis magnis sed consequat orci."
        },
        de: {
            includedTitle: "Was enthalten ist",
            solutionTitle: "Maßgeschneiderte Lösung",
            sampleText: "Netus platea nec commodo tincidunt felis orci iaculis facilisi. Molestie etiam magnis rutrum penatibus eros non accumsan erat nulla,",
            longText: "Netus platea nec commodo tincidunt felis orci iaculis facilisi. Molestie etiam magnis rutrum penatibus eros non accumsan erat nulla, convallis rhoncus natoque lacinia class viverra platea cubilia, netus luctus tristique quam habitasse taciti nullam fringilla nostra netus class felis magnis sed consequat orci."
        }
    };

    const t = translations[language] || translations.gb;

    return (
        <div style={{ 
            padding: '40px', 
            fontFamily: isRtl ? "'Tahoma', sans-serif" : 'Arial, sans-serif', 
            lineHeight: 1.6,
            direction: isRtl ? 'rtl' : 'ltr'
        }}>
            <Section
                title={t.includedTitle}
                items={[t.sampleText, t.sampleText, t.sampleText]}
                paragraphs={[t.longText, t.longText]}
                isRtl={isRtl}
            />

            <Section
                title={t.solutionTitle}
                items={[t.sampleText, t.sampleText, t.sampleText]}
                isRtl={isRtl}
            />
        </div>
    );
};

export default IncludedAndSolution;